import { render, staticRenderFns } from "./solicitacaoIcons.vue?vue&type=template&id=9e8fa1d4&scoped=true"
import script from "./solicitacaoIcons.ts?vue&type=script&lang=ts&external"
export * from "./solicitacaoIcons.ts?vue&type=script&lang=ts&external"
import style0 from "./solicitacaoIcons.vue?vue&type=style&index=0&id=9e8fa1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8fa1d4",
  null
  
)

export default component.exports